import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone, Plus, X } from "lucide-react";
import { useSiteContent } from "../../context/SiteContent";

export const QuickActions = () => {
  const { content } = useSiteContent();
  const ci = content?.companyInfo || {};
  const [open, setOpen] = useState(false);

  const actions = [
    { label: "WhatsApp", href: `https://wa.me/${ci.whatsappNumber || "919998147181"}`, icon: MessageCircle, cls: "bg-emerald-500 hover:bg-emerald-600", testid: "quick-whatsapp", ext: true },
    { label: `Call ${ci.contact1Name || "Darshan"}`, href: `tel:${(ci.contact1Phone || "+919998147181").replace(/\s/g, "")}`, icon: Phone, cls: "bg-helios-cyan hover:bg-helios-cyan/90", testid: "quick-call-1" },
    { label: `Call ${ci.contact2Name || "Kirtan"}`, href: `tel:${(ci.contact2Phone || "+917211150088").replace(/\s/g, "")}`, icon: Phone, cls: "bg-helios-slate hover:bg-helios-slate/90", testid: "quick-call-2" },
  ];

  return (
    <div className="fixed bottom-5 right-5 z-[90] flex flex-col items-end gap-3" data-testid="quick-actions">
      <AnimatePresence>
        {open && actions.map((a, i) => (
          <motion.a key={a.testid} href={a.href} target={a.ext ? "_blank" : undefined} rel={a.ext ? "noopener noreferrer" : undefined}
            initial={{ opacity: 0, y: 12, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.8 }} transition={{ delay: i * 0.05, duration: 0.25 }}
            className="group flex items-center gap-3" data-testid={a.testid}>
            <span className="rounded-full bg-white shadow-md border border-helios-line px-3 py-1.5 text-xs font-medium text-helios-slate whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
              {a.label}
            </span>
            <span className={`flex items-center justify-center w-12 h-12 rounded-full text-white shadow-lg transition-colors ${a.cls}`}>
              <a.icon size={20} />
            </span>
          </motion.a>
        ))}
      </AnimatePresence>
      <button onClick={() => setOpen(!open)} aria-label="Quick actions" data-testid="quick-toggle"
        className="flex items-center justify-center w-14 h-14 rounded-full bg-helios-amber text-helios-slate shadow-xl hover:scale-105 active:scale-95 transition-transform">
        <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.25 }}>
          {open ? <X size={24} /> : <Plus size={24} />}
        </motion.span>
      </button>
    </div>
  );
};
